import { render, staticRenderFns } from "./DrinkerResultsWeekly.vue?vue&type=template&id=0e822c1f&scoped=true&"
import script from "./DrinkerResultsWeekly.vue?vue&type=script&lang=ts&"
export * from "./DrinkerResultsWeekly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e822c1f",
  null
  
)

export default component.exports